<template>
  <a-form
    class="search-form-comp" layout="inline" :form="searchForm"
    :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
    @submit.prevent="handlerSearch"
  >
    <a-row :gutter="24">
      <a-col v-for="item in searchItems" :key="item.label" :span="item.span || 8">
        <a-form-item :label="item.label" >

          <!-- 普通输入框 -->
          <a-input
            v-if="item.type==='input'" type="text"
            v-decorator="item.decorator" :placeholder="item.placeholder"
          >
          </a-input>
          <!-- 数值输入框 -->
          <a-input
            v-if="item.type==='number'" type="number" :addonBefore="item.addonBefore || null"
            v-decorator="item.decorator" :placeholder="item.placeholder"
          >
          </a-input>

          <!-- 下拉选择框 -->
          <a-select
            v-else-if="item.type==='select'"
            v-decorator="item.decorator" :placeholder="item.placeholder"
            showArrow showSearch allowClear optionFilterProp="children"
            :maxTagCount="3" :maxTagTextLength="100"
            :getPopupContainer="trigger => trigger.parentElement"
            :mode="item.mode||'default'" :class="{'scroll-selection': item.mode === 'multiple'}"
          >
            <a-select-option
              class="text-left"
              v-for="o in item.option.data"
              :key="o[item.option.keyName || 'id']"
              :value="o[item.option.keyName || 'id']"
            >{{o[item.option.valName || 'name']}}</a-select-option>
          </a-select>
          <!-- 远程查询数据的下拉选择 -->
          <a-select
            v-else-if="item.type==='querySelect'"
            v-decorator="item.decorator" :placeholder="item.placeholder"
            showSearch allowClear optionFilterProp="children"
            :showArrow="false" :filterOption="false"
            :getPopupContainer="trigger => trigger.parentElement"
            :disabled="item.disabled"
            @search="value => handlerQuerySelectSearching(value, item)"
            @change="value => handlerQuerySelectChanging(value, item)"
          >
            <a-spin v-if="item.loading" slot="notFoundContent" size="small" />
            <a-select-option
              v-else class="text-left"
              v-for="o in item.option.data"
              :key="o[item.option.keyName || 'id']"
              :value="o[item.option.keyName || 'id']"
            >{{o[item.option.valName || 'name']}}</a-select-option>
          </a-select>

          <!-- cascader -->
          <a-cascader
            v-else-if="item.type==='cascader'"
            v-decorator="item.decorator" :placeholder="item.placeholder"
            :options="item.options"
          />
          <!--输入框组合-->
          <a-input-group
            v-if="item.type==='inputGroup'"
          >
            <a-input
              style="width: calc(50% - 15px); text-align: center"
              v-decorator="item.child[0].keyName" :placeholder="item.child[0].placeholder"
            />
            <a-input
              style="width: 30px; border-left: 0; pointer-events: none; background-color: #fff"
              placeholder="~"
              disabled
            />
            <a-input
              style="width: calc(50% - 15px); text-align: center; border-left: 0"
              v-decorator="item.child[1].keyName" :placeholder="item.child[1].placeholder"
            />
          </a-input-group>
          <!-- 日期选择 -->
          <a-date-picker
            v-else-if="item.type==='datePicker'"
            format="YYYY-MM-DD" style="width: 100%"
            v-decorator="item.decorator" :placeholder="item.placeholder"
            :disabledDate="item.disabledDate"
            :getCalendarContainer="trigger => trigger.parentElement"
          />

          <!-- 时间范围 -->
          <a-range-picker
            v-else-if="item.type==='timeRange'"
            showTime format="YYYY-MM-DD HH:mm:ss" style="width: 100%"
            v-decorator="item.decorator" :placeholder="item.placeholder"
            :disabledDate="item.disabledDate"
            :ranges="item.ranges"
            :getCalendarContainer="trigger => trigger.parentElement"
          />

          <a-switch
            v-else-if="item.type==='switch'"
            checked-children="是"
            un-checked-children="否"
            v-decorator="item.decorator"
          />

        </a-form-item>

      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24" :style="{ textAlign: 'right' }">
        <a-button type="primary" html-type="submit" :loading="searching">
          搜索
        </a-button>
        <a-button style="margin-left:10px" @click="handlerReset">
          重置
        </a-button>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'SearchForm',
  props: {
    searchItems: {
      type: Array,
      default: () => [],
      require: true
    },
    searching: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchForm: this.$form.createForm(this),
      expand: false
    }
  },
  methods: {
    handlerSearch() {
      this.searchForm.validateFields(async (err, values) => {
        if (!err) {
          this.$emit('search', values)
        }
      })
    },
    handlerReset() {
      this.resetFields()
      this.$emit('formReseted', this.searchForm)
      this.handlerSearch()
    },

    resetFields() {
      this.searchForm.resetFields()
    },
    setFieldsValue(data) {
      this.searchForm.setFieldsValue(data)
    },

    handlerQuerySelectSearching(value, item) {
      if (item.searchFn) {
        item.searchFn(value, this.searchForm)
      }
      return value
    },
    handlerQuerySelectChanging(value, item) {
      if (item.changeFn) {
        item.changeFn(value, this.searchForm)
      }
      return value
    }
  }
})
</script>

<style lang="less" scoped>
.search-form-comp {

  ::v-deep .ant-form-item {
    display: flex;
    margin-right: 0;
    margin-bottom: 12px;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
}
</style>
